import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";

interface IProtectedRouteProps {
  state: string;
  children: ReactNode;
}

function ProtectedRoute({ state, children }: IProtectedRouteProps) {
  const location = useLocation();
  const currentState = location.state?.[state];
  if (currentState === null || currentState === undefined) {
    return <Navigate to={"/"} />;
  }
  return <>{children}</>;
}

export default ProtectedRoute;
